import { render } from "./CheckoutPolicy.vue?vue&type=template&id=14e2843a&scoped=true&ts=true"
import script from "./CheckoutPolicy.vue?vue&type=script&lang=ts"
export * from "./CheckoutPolicy.vue?vue&type=script&lang=ts"

import "./CheckoutPolicy.vue?vue&type=style&index=0&id=14e2843a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e2843a"]])

export default __exports__